import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "alt-react";
import Translate from "react-translate-component";
import ReactTooltip from "react-tooltip";
import BackupStore from "stores/BackupStore";
import BackupActions from "actions/BackupActions";
import DecryptBackup from "./DecryptBackup";
import Icon from "../Icon/Icon";

class WalletLogin extends Component {
  static propTypes = {
    active: PropTypes.bool,
    backup: PropTypes.object,
    onChangeActive: PropTypes.func.isRequired,
    goToAccountModel: PropTypes.func.isRequired
  };
  static defaultProps = {
    active: false,
    backup: {}
  };

  constructor(props) {
    super(props);
    this.state = {
      isDrop: false
    };
  }

  componentDidMount() {
    BackupActions.reset();
  }

  onFileUpload(evt, droppedFile) {
    const file = droppedFile || evt.target.files[0];
    BackupActions.incommingWebFile(file);
    this.forceUpdate();
  }

  onDropBinFile(e) {
    e.preventDefault();
    this.onFileUpload(e, e.dataTransfer.files[0]);
  }

  onPlaceFile(isOpen) {
    this.setState({
      isDrop: isOpen
    });
  }

  renderTooltip() {
    return /*#__PURE__*/React.createElement(ReactTooltip, {
      id: "without-bin",
      className: "custom-tooltip text-left",
      globalEventOff: "click"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tooltip-text",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "tooltip.login-tooltip.withoutBinFileBlock.begin"
    }), /*#__PURE__*/React.createElement(Link, {
      to: "/create-wallet-brainkey"
    }, /*#__PURE__*/React.createElement(Translate, {
      component: "u",
      className: "active-upload-text cursor-pointer",
      content: "tooltip.login-tooltip.withoutBinFileBlock.brainkey"
    })), /*#__PURE__*/React.createElement(Translate, {
      content: "tooltip.login-tooltip.withoutBinFileBlock.middle"
    }), /*#__PURE__*/React.createElement(Translate, {
      onClick: this.props.goToAccountModel,
      className: "without-bin cursor-pointer",
      content: "tooltip.login-tooltip.withoutBinFileBlock.model"
    }), /*#__PURE__*/React.createElement(Translate, {
      content: "tooltip.login-tooltip.withoutBinFileBlock.end"
    }), /*#__PURE__*/React.createElement("span", {
      onClick: () => ReactTooltip.hide(),
      className: "close-button"
    }, "\xD7")));
  }

  renderUploadInputForSmall() {
    const isDownloaded = this.props.backup.contents && this.props.backup.public_key;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "text-left left-label show-for-small-only"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: this.props.backup.contents ? "login.selectDifferent" : "login.browseFileLabel"
    })), /*#__PURE__*/React.createElement("div", {
      onDragOver: e => e.preventDefault(),
      onDragEnter: e => e.preventDefault(),
      onDrop: e => this.onDropBinFile(e),
      className: "small-container"
    }, isDownloaded ? /*#__PURE__*/React.createElement("span", {
      className: "bin-name"
    }, this.props.backup.name) : /*#__PURE__*/React.createElement("span", null, "\xA0"), /*#__PURE__*/React.createElement("span", {
      className: "upload-text"
    }, /*#__PURE__*/React.createElement("u", {
      className: "active-upload-text"
    }, /*#__PURE__*/React.createElement("input", {
      ref: "file_input",
      accept: ".bin",
      type: "file",
      id: "backupFile",
      className: "upload-bin-input",
      onChange: e => this.onFileUpload(e)
    }), /*#__PURE__*/React.createElement(Icon, {
      name: "paperclip",
      className: "attach-bin"
    })))));
  }

  renderUploadInput() {
    const {
      isDrop
    } = this.state;
    const {
      backup
    } = this.props;
    const isInvalid = backup.contents && !backup.public_key;
    const isDownloaded = backup.contents && backup.public_key;
    return /*#__PURE__*/React.createElement("label", {
      onDragOver: () => {
        this.onPlaceFile(true);
      },
      onDragLeave: () => {
        this.onPlaceFile(false);
      },
      className: "cursor-pointer",
      htmlFor: "backupFile"
    }, /*#__PURE__*/React.createElement("div", {
      onDragOver: e => e.preventDefault(),
      onDrop: e => this.onDropBinFile(e),
      className: `file-input-container ${isInvalid ? "invalid" : ""} ${isDrop ? "dropHover" : ""} ${isDownloaded ? "downloaded" : ""}`
    }, /*#__PURE__*/React.createElement("img", {
      className: "rounded-arrow",
      src: "bin-file/rounded-arrow.svg",
      alt: "arrow"
    }), isDownloaded ? /*#__PURE__*/React.createElement("img", {
      className: "bin-file",
      src: "bin-file/downloaded.svg",
      alt: "bin-file"
    }) : isInvalid ? /*#__PURE__*/React.createElement("img", {
      className: "bin-file",
      src: "bin-file/error.svg",
      alt: "bin-file"
    }) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
      className: "bin-file initial-bin",
      src: "bin-file/hover.svg",
      alt: "bin-file"
    })), /*#__PURE__*/React.createElement("span", {
      className: "upload-text text-left no-overflow"
    }, isDownloaded ? /*#__PURE__*/React.createElement("p", {
      className: "bin-name"
    }, this.props.backup.name, " (", this.props.backup.size, " bytes)") : isInvalid ? /*#__PURE__*/React.createElement(Translate, {
      className: "facolor-error",
      content: "login.invalidFormat"
    }) : /*#__PURE__*/React.createElement(Translate, {
      content: "login.dropFile"
    }), /*#__PURE__*/React.createElement("u", {
      className: "active-upload-text"
    }, /*#__PURE__*/React.createElement("input", {
      ref: "file_input",
      accept: ".bin",
      type: "file",
      id: "backupFile",
      className: "upload-bin-input",
      onChange: e => this.onFileUpload(e)
    }), /*#__PURE__*/React.createElement(Translate, {
      content: this.props.backup.contents ? "login.selectDifferent" : "login.browseFile"
    })))));
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      onClick: this.props.onChangeActive,
      className: "wallet-block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "overflow-bg-block show-for-small-only"
    }, /*#__PURE__*/React.createElement("span", {
      className: "content"
    })), new FileReader().readAsBinaryString || !this.props.active ? null : /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      className: "error",
      content: "login.supportWarning"
    }), /*#__PURE__*/React.createElement("div", {
      className: !this.props.active ? "display-none" : ""
    }, this.renderUploadInput(), this.renderUploadInputForSmall(), /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      className: "text-left without-bin cursor-pointer hide-for-small-only",
      content: "login.withoutBinFile",
      "data-for": "without-bin",
      "data-tip": true,
      "data-event": "click",
      "data-place": "right",
      "data-effect": "solid"
    }), /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      className: "text-left without-bin cursor-pointer show-for-small-only",
      content: "login.withoutBinFile",
      "data-for": "without-bin",
      "data-tip": true,
      "data-event": "click",
      "data-place": "bottom",
      "data-effect": "solid"
    }), this.renderTooltip()), /*#__PURE__*/React.createElement(DecryptBackup, {
      active: this.props.active,
      history: this.props.history
    }));
  }

}

const connectObject = {
  listenTo() {
    return [BackupStore];
  },

  getProps() {
    return {
      backup: BackupStore.getState()
    };
  }

};
export default connect(WalletLogin, connectObject);